<template>
  <div class="entry-overview flex overflow-hidden bg-white shadow sm:rounded-lg">
    <!-- Client entry detail -->
    <div class="entry-detail w-full">
      <article>
        <div
          v-if="project.archived_at !== null"
          class="flex w-full items-center justify-center gap-x-6 bg-indigo-600 px-6 py-2.5 sm:px-3.5">
          <p class="text-sm leading-6 text-white">
            <strong class="font-semibold">Project is archived</strong> - <i
              class="cursor-pointer underline hover:text-white"
              @click="restore">click here to restore</i>
          </p>
        </div>
        <!-- Profile header -->
        <div>
          <div class="mx-auto px-4 sm:px-6 lg:px-8">
            <div class="sm:flex sm:items-end sm:space-x-5">
              <div class="mt-2 sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
                <div class="mt-6 min-w-0 flex-1 2xl:block">
                  <p class="text-xs">
                    Project id: {{ project.id }}
                  </p>
                  <h1 class="truncate text-2xl font-bold text-font-darkest">
                    {{ project.name }}
                  </h1>
                </div>
                <div class="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">
                  <Link :href="route('proposals.create')">
                    <!-- needs to send data to create proposal, to have fields prefilled with project data -->
                    <button
                      type="button"
                      class="inline-flex justify-center rounded-md border border-font-lightest bg-white px-4 py-2
                      text-sm font-medium text-font-dark shadow-sm hover:bg-gray-50 focus:outline-none
                      focus:ring-2 focus:ring-primary focus:ring-offset-2">
                      <!-- Heroicon name: solid/folder-add -->
                      <svg
                        class="-ml-1 mr-2 size-5 text-font-light"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true">
                        <path
                          clip-rule="evenodd"
                          d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 00-2 0v1H8a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1V9z"
                          fill-rule="evenodd" />
                      </svg>
                      <span>New proposal</span>
                    </button>
                  </Link>
                  <button
                    type="button"
                    class="inline-flex cursor-pointer justify-center rounded-md border border-font-lightest bg-white px-4 py-2
                      text-sm font-medium text-font-dark shadow-sm hover:bg-gray-50
                      focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    @click="showActivityForm = true;">
                    <DocumentTextIcon
                      class="-ml-1 mr-2 size-5 text-font-light"
                      aria-hidden="true" />
                    <span>Log an activity or a note</span>
                  </button>
                  <button
                    v-if="project.archived_at === null"
                    type="button"
                    class="inline-flex justify-center rounded-md border border-font-lightest bg-white px-4 py-2
                      text-sm font-medium text-font-dark shadow-sm hover:bg-gray-50 focus:outline-none
                      focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    @click="archive">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="-ml-1 mr-2 size-5 text-font-light">
                      <path d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" />
                      <path
                        fill-rule="evenodd"
                        d="m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.163 3.75A.75.75 0 0 1 10 12h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z"
                        clip-rule="evenodd" />
                    </svg>
                    <span>Archive</span>
                  </button>
                  <button
                    v-else
                    type="button"
                    class="inline-flex justify-center rounded-md border border-font-lightest bg-white px-4 py-2
                      text-sm font-medium text-font-dark shadow-sm hover:bg-gray-50 focus:outline-none
                      focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    @click="restore">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="-ml-1 mr-2 size-5 text-font-light">
                      <path d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" />
                      <path
                        fill-rule="evenodd"
                        d="m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087ZM12 10.5a.75.75 0 0 1 .75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 0 1 .75-.75Z"
                        clip-rule="evenodd" />
                    </svg>

                    <span>Restore</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="mt-2">
          <div class="border-b border-gray-200">
            <div class="flex justify-center px-4 sm:px-6 lg:px-8">
              <nav
                class="-mb-px flex space-x-8"
                aria-label="Tabs">
                <tab-link
                  :href="route('projects.show', {project: project})"
                  :active="route().current('projects.show')">
                  Overview
                </tab-link>
                <tab-link
                  :href="route('projects.activities', {project: project})"
                  :active="route().current('projects.activities')">
                  Activities
                </tab-link>
              </nav>
            </div>
          </div>
        </div>

        <slot />
      </article>
    </div>

    <SimpleModalSmall
      :show="showActivityForm">
      <AddActivityForm
        :project="project"
        @close="showActivityForm = false" />
    </SimpleModalSmall>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';

import { router as Inertia } from '@inertiajs/core';
import { DocumentTextIcon } from '@heroicons/vue/24/solid';
import SimpleModalSmall from '@/Components/Modals/SimpleModalSmall.vue';
import Modal from '../../Jetstream/Modal.vue';
import AddActivityForm from '../../ComponentsDeprecated/AddActivityForm.vue';
import TabLink from '../../ComponentsDeprecated/TabLink.vue';

export default {
  components: {
    SimpleModalSmall,
    DocumentTextIcon,
    TabLink,
    Modal,
    AddActivityForm,
    Link,
  },

  props: {
    project: Object,
  },

  data() {
    return {
      showActivityForm: false,
      activity: 'call',
    };
  },

  computed: {},
  watch: {},
  methods: {
    archive() {
      Inertia.put(route('projects.archive', { project: this.project.id }));
    },

    restore() {
      Inertia.put(route('projects.restore', { project: this.project.id }));
    },
  },
};
</script>

<style lang="scss" scoped>
//
</style>
